import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { Container, Card, Row, Col, Accordion, Button, Modal, Form, Offcanvas } from "react-bootstrap";
import { FaClipboardList, FaSmile, FaInfoCircle, FaRegCalendarCheck, FaHospitalUser, FaUserFriends, FaStar } from 'react-icons/fa';
import Glide from "@glidejs/glide";
import "@glidejs/glide/dist/css/glide.core.min.css";
import "@glidejs/glide/dist/css/glide.theme.min.css";
import Center from "react-center";
import Step1Page from "./registrasi/Step1Page";
import Step2Page from "./registrasi/Step2Page";
import Step3Page from "./registrasi/Step3Page";
import Step4Page from "./registrasi/Step4Page";
import Step6Page from "./registrasi/Step6Page";
import SuccessPage from "./registrasi/SuccessPage";

import { style } from "view/Style";
import Axios from "axios";
import { urlAPI } from "Common";
import FailedAlert from "./component/FailedAlert";
import InfoAlert from "./component/InfoAlert";
import ConfirmationAlert from "./component/ConfirmationAlert";
import moment from "moment";
import { FloatingWhatsApp } from "react-floating-whatsapp-button";
import "react-floating-whatsapp-button/dist/index.css";
import JadwalSection from "./jadwal/JadwalSection";
import AntrianSection from "./jadwal/AntrianSection";
import { useHistory } from "react-router-dom";
import ModalPengumuman from "./component/ModalPengumuman";
import PelangganSection from "./jadwal/PelangganSection";
import ModalHeader from "react-bootstrap/esm/ModalHeader";

const initStep1 = {
  sbu: null,
  sbuname: null,
  unit: null,
  unitname: null,
  date: moment().add(0, "days").format("YYYY-MM-DD"),
  rs: "",
};
const initStep2 = {
  idjadwal: null,
  kodedokter: null,
  namadokter: null,
  kodedokterbpjs: null,
  kodeunitbpjs: null,
  ruang: null,
  jam: null,
};
const initStep3 = {
  norm: null,
  nama: null,
  tgllahir: null,
  namacust: null,
  jaminan: null,
  noktp: null,
  noasuransi: "",
  paketmcu:"",
};
const initStep4 = { tlp: "", nonBpjs: "0" };
const initDataBPJS = {
  kodedokterbpjs: null,
  kodeunitbpjs: null,
  kuota: 0,
};

// const initStep1 = {
//   sbu: "RSPG",
//   sbuname: "Rumah Sakit Petrokimia Gresik",
//   unit: "Q03",
//   unitname: "SPESIALIS PNY.DALAM",
//   date: moment("2021-08-09").format("YYYY-MM-DD"),
// };
// const initStep2 = {
//   kodedokter: "S74",
//   namadokter: "ABDUL FATAH, SP.PD",
//   ruang: "POLI 6",
//   jam: "08:30 - 11:00",
// };
// const initStep3 = {
//   norm: "558662",
//   nama: "SRI SETYOWATI",
//   tgllahir: "1957-11-20 00:00:00.000",
//   namacust: "BPJS KESEHATAN ",
// };

const initSuccessState = {
  sbuname: "",
  unitname: "",
  doktername: "",
  tanggal: "",
  jam: "",
  nobooking: "",
  antrian: "",
};

const initFilterJadwal = {
  sbu: null,
  poli: null,
  namapoli: "",
};
const initFilterAntrian = {
  sbu: null,
  poli: null,
  namapoli: "",
};

const initFilterRiwayat = {
  nama: "",
  poli: "",
  doktername: "",
  tanggal: "",
  unitname: "",
  sbuname: "",
}

const initSEP = 0;

export default function App(props) {
  const myRef = useRef(null);
  const sliderRef = useRef(null);
  const [activeStep, setActiveStep] = useState(1);
  const [dataStep1, setDataStep1] = useState({ sbu: "", unit: "", date: "" });
  const [dataStep2, setDataStep2] = useState(initStep2);
  const [dataStep3, setDataStep3] = useState(initStep3);
  const [dataStep4, setDataStep4] = useState(initStep4);
  const [dataBPJS, setDataBPJS] = useState(initDataBPJS);
  const [SEP, setSEP] = useState(initSEP);
  const [dataRujukan, setDataRujukan] = useState([]);
  const [filterJadwal, setFilterJadwal] = useState(initFilterJadwal);
  const [filterAntrian, setFilterAntrian] = useState(initFilterAntrian);
  const [suratKontrol, setSuratKontrol] = useState([]);
  const [filterRiwayat, setFilterRiwayat] = useState(initFilterRiwayat);

  const [successState, setSuccessState] = useState(initSuccessState);
  const history = useHistory();

  const [messageState, setMessageState] = useState("");
  const [showFailed, setShowFailed] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationFrom, setConfirmationFrom] = useState(null);
  const [showInfo, setShowInfo] = useState(false);

  const [selectorUnit, setSelectorUnit] = useState([]);
  const [loadingUnit, setLoadingUnit] = useState(false);
  const [unitJenis3, setUnitJenis3] = useState(null);
  const [handleNext, sethandleNext] = useState([]);

  const [selectorAntrian, setSelectorAntrian] = useState([]);
  const [loadingAntrian, setLoadingAntrian] = useState(false);
  const [antrianJenis3, setAntrianJenis3] = useState(null);

  const [loadingPengumuman, setLoadingPengumuman] = useState(false);
  const [openPengumuman, setOpenPengumuman] = useState(false);
  const [dataPengumuman, setDataPengumuman] = useState({});
  const [tanggalServer, setTanggalServer] = useState(null);
  const [tanggalClient, setTanggalClient] = useState(null);
  const [statusKirimBPJS, setStatusKirimBPJS] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [selectedSBU, setSelectedSBU] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showUnitDateModal, setShowUnitDateModal] = useState(false);
  const [visitDate, setVisitDate] = useState(null);
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [modalHistory, setModalHistory] = useState([]);


  const handleOpenModal = (menu) => {
    setSelectedMenu(menu);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMenu(null);
  };

  const handleSelectSBU = (sbu) => {
    setSelectedSBU(sbu);
    setDataStep1({ ...dataStep1, sbu: sbu.value, unit: "", date: "" });
    setShowModel(true);
  };
  
  
  console.log (dataStep1?.sbu)
  const handleHospitalSelect = (sbu) => {
    fetchSelectorUnit(sbu.value);
    // setDataStep1({ ...dataStep1, sbu: sbu.value, sbuname: sbu.label, unit: null, unitname: null });
    setShowUnitDateModal(true);
  };
  
  const handleUnitSelect = (e) => {
    setDataStep1({ ...dataStep1, unit: e.value, unitname: e.label });
    setUnitJenis3(e.jenis3);
  };
  
  
  const handleDateSelect = () => {
    setDataStep1({ ...dataStep1, visitDate: visitDate });
    setShowUnitDateModal(false);
    setShowRegistrationModal(true);
    setModalHistory(["registration"]);
  };  

  const handleRegistrationModalClose = (registered) => {
    setDataStep1({ ...dataStep1, rs: registered ? "Pernah" : "Belum" });
    setShowRegistrationModal(false);
    setModalHistory([]);
    handleNext();
  }; 
  
  const handleSelect = (sbu) => {
    // setDataStep1({ ...dataStep1, sbu: sbu, unit: null, unitname: null });
    setSelectedSBU(sbu);
    setShowPopup(true);
  };
  
  const [selectorRS] = useState([
    {
      value: "Pernah",
      label: "Pernah",
    },
    {
      value: "Belum",
      label: "Belum",
    },
  ]);

  const selectorSBU = [
    { value: "RSPG", 
      label: "Rumah Sakit Petrokimia Gresik", 
      location: "https://goo.gl/maps/Kaugv4ev8JbqkSDr7", 
      img: "assets/img/rspgnew.png", 
      profile: "RS Petrokimia Gresik (RSPG) adalah rumah sakit umum yang berlokasi di Jl. Jenderal Ahmad Yani, Gresik. Berawal sebagai poliklinik pada 1971, RSPG resmi menjadi rumah sakit pada 11 Maret 1992 dan dikelola oleh PT Petro Graha Medika sejak 2004. Dengan fasilitas modern dan tenaga medis profesional, RSPG berkomitmen memberikan pelayanan kesehatan terbaik bagi masyarakat."
     },
      
    { value: "GRAHU", 
      label: "Rumah Sakit Grha Husada", 
      location: "https://goo.gl/maps/YtnjVQkmEX7m9tXD9", 
      img: "assets/img/rsghnew.png", 
      profile: "RS Grha Husada Gresik adalah rumah sakit umum kelas D yang beroperasi sejak 31 Desember 2013. Berada di bawah naungan PT Petro Graha Medika, rumah sakit ini berlokasi di Jl. Padi No. 03, Komplek Perumahan PT Petrokimia Gresik. Ditetapkan sebagai RS kelas D oleh Kemenkes RI pada 25 Oktober 2013, RS Grha Husada menyediakan layanan kesehatan terintegrasi bagi masyarakat." },

    { value: "DRIYO", 
      label: "RSPG Driyorejo", 
      location: "https://goo.gl/maps/RCTEzS4JEMgRGNwt8", 
      img: "assets/img/rspgd.png", 
      profile: "RS Petrokimia Gresik Driyorejo (RSPG Driyorejo) adalah rumah sakit umum yang berlokasi di Driyorejo, Gresik. Sebagai bagian dari PT Petro Graha Medika, rumah sakit ini berkomitmen memberikan layanan kesehatan berkualitas dengan fasilitas modern dan tenaga medis profesional. Dengan pelayanan yang cepat, aman, dan berkualitas, RSPG Driyorejo hadir untuk memenuhi kebutuhan kesehatan masyarakat sekitar." },

    // { value: "PPK1", 
    //   label: "Klinik PPK I PT Petrokimia Gresik", 
    //   location: "https://goo.gl/maps/4xYCCL2nRrFaBq9k9",  
    //   img: "assets/img/logoppk.png", 
    //   profile: "Klinik PPK I PT Petrokimia Gresik memberikan layanan kesehatan bagi karyawan dan masyarakat sekitar." },

    // { value: "KALIMANTAN", 
    //   label: "Klinik Satelit Kalimantan", 
    //   location: "https://goo.gl/maps/9pMZG3iPkkdbD5o88", 
    //   img: "assets/img/logosatkal.png", 
    //   profile: "Klinik Satelit Kalimantan menyediakan layanan kesehatan dasar dan spesialis." },

    // { value: "WA", 
    //   label: "Klinik PPK I Wringinanom Gresik", 
    //   location: "https://goo.gl/maps/cDmnMQjzbGARio539", 
    //   img: "assets/img/logoppk.png", 
    //   profile: "Klinik PPK I Wringinanom Gresik menyediakan layanan kesehatan dasar dan spesialis." },
  ];
  

  const menuLayanan = [
    {
      label: "Daftar Online",
      icon: <FaClipboardList size={40} color="#097a75" />,
      component: "PelangganSection",
    },
    {
      label: "Riwayat Kunjungan",
      icon: <FaUserFriends size={40} color="#097a75" />,
      component: "PelangganSection",
    },
    {
      label: "Jadwal Dokter",
      icon: <FaHospitalUser size={40} color="#097a75" />,
      component: "JadwalSection",
    },
    {
      label: "Informasi Antrian",
      icon: <FaInfoCircle size={40} color="#097a75" />,
      component: "AntrianSection",
    },
    {
      label: "Rencana Kontrol",
      icon: <FaRegCalendarCheck size={40} color="#097a75" />,
      component: "AntrianSection",
    },
    {
      label: "Kuisioner Pelanggan",
      icon: (
        <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
          <FaStar size={8} color="#097a75" />
          <FaStar size={16} color="#097a75" />
          <FaStar size={24} color="#097a75" />
          <FaStar size={16} color="#097a75" />
          <FaStar size={8} color="#097a75" />
        </div>
      ),
      component: "PelangganSection",
    },    
  ];

  const [noBPJS, setNoBPJS] = useState(""); //digunakan kalau user memilih jaminan bpjs dan jenis pengenal bukan nomor bpjs
  // console.log("dataStep 1",dataStep1);
  // console.log("dataStep 2", dataStep2);
  // console.log("dataStep 3", dataStep3);
  // console.log("surat Kontrol", suratKontrol[0]?.noSuratKontrol);
  // console.log("dataBPJS", dataBPJS);
  // console.log("SEP", SEP);
  const fetchSelectorUnit = (sbu) => {
    Axios.get(urlAPI + "/public/unit/selectorrawatjalan?sbu=" + sbu)
      .then((response) => {
        if (response?.data?.result?.length > 0) {
          const pilihanNull = { value: null, label: "Pilih Unit Tujuan..." };
          const selectorTemp = response?.data?.result?.map((obj) => ({
            value: obj?.KODEUNIT,
            label: obj?.NAMAUNIT,
            name: obj?.NAMAUNIT,
            jenis3: obj?.JENIS3,
          }));
          setSelectorUnit([pilihanNull, ...selectorTemp]);
          setLoadingUnit(false);
        } else {
          setSelectorUnit([]);
          setLoadingUnit(false);
        }
      })
      .catch((err) => {
        setMessageState(err?.response?.data?.message ?? err?.response);
        setShowFailed(true);
        setLoadingUnit(false);
      });
  };

  const fetchSelectorUnitAntrian = (sbu) => {
    Axios.get(urlAPI + "/public/unit/selectorrawatjalan?sbu=" + sbu)
      .then((response) => {
        if (response?.data?.result?.length > 0) {
          const pilihanNull = { value: null, label: "Pilih Unit Tujuan..." };
          const selectorTemp = response?.data?.result?.map((obj) => ({
            value: obj?.KODEUNIT,
            label: obj?.NAMAUNIT,
            name: obj?.NAMAUNIT,
            jenis3: obj?.JENIS3,
          }));
          setSelectorAntrian([pilihanNull, ...selectorTemp]);
          setLoadingAntrian(false);
        } else {
          setSelectorAntrian([]);
          setLoadingAntrian(false);
        }
      })
      .catch((err) => {
        setMessageState(err?.response?.data?.message ?? err?.response);
        setShowFailed(true);
        setLoadingUnit(false);
      });
  };

  const cekTanggalServer = () => {
    Axios.get(urlAPI + "/public/regonline/cektanggal")
      .then((response) => {
        setTanggalServer(response?.data?.result[0]?.Tanggal);
        setTanggalClient(moment(new Date()).format("YYYY-MM-DD"));

        if (
          moment(new Date()).format("YYYY-MM-DD") !==
          response?.data?.result[0]?.Tanggal
        ) {
          setMessageState("Tanggal Perangkat Tidak Sesuai Dengan Server");
          setShowFailed(true);
          setLoadingUnit(false);
        } else {
          setLoadingPengumuman(true);
          fetchCheckPengumuman();
        }
      })
      .catch((err) => {
        setMessageState(err?.response?.data?.message ?? err?.response);
        setShowFailed(true);
        setLoadingUnit(false);
      });
  };

  // console.log('tanggal server', tanggalServer);
  // console.log('tanggal client', tanggalClient);
  const fetchCheckPengumuman = () => {
    Axios.get(
      urlAPI + "/public/regonline/checkpengumuman?sbu=" + dataStep1?.sbu
    )
      .then((response) => {
        setLoadingPengumuman(false);
        if (response?.data?.result?.length > 0) {
          setDataPengumuman({
            ...response?.data?.result[0],
          });
          setActiveStep(activeStep + 1);
          myRef.current.scrollIntoView();
          setOpenPengumuman(true);
        } else {
          setOpenPengumuman(false);
          setDataPengumuman({});
          setActiveStep(activeStep + 1);
          myRef.current.scrollIntoView();
        }
      })
      .catch((err) => {
        setMessageState(err?.response?.data?.message ?? err?.response);
        setShowFailed(true);
        setLoadingUnit(false);
      });
  };

  /*eslint-disable */
  useEffect(() => {
    if (
      dataStep1?.sbu !== null &&
      dataStep1?.unit !== null &&
      dataStep1?.date !== null &&
      dataStep1?.rs !== null &&
      moment(dataStep1.date).isValid()
    ) {
      setLoadingUnit(true);
      fetchSelectorUnit(dataStep1?.sbu);
      fetchSelectorUnitAntrian(dataStep1?.sbu);
    }
  }, []);
  
  useEffect(() => {
    if (!showModal) {
      setActiveStep(1);
      setDataStep1(initStep1);
      setDataStep2(initStep2);
      setDataStep3(initStep3);
      setDataStep4(initStep4);
      setDataBPJS(initDataBPJS);
      setSuccessState(initSuccessState);
    }
  }, [showModal]);

  useEffect(() => {
    if (window.innerWidth < 768 && sliderRef.current) {
      const glide = new Glide(sliderRef.current, {
        type: "carousel",
        perView: 1,
        autoplay: 3000,
        hoverpause: true,
      });

      glide.mount();
      return () => glide.destroy();
    }
  }, []);

  useEffect(() => {
    if (selectedMenu?.label === "Daftar Online") {
      setShowUnitDateModal(true);
    }
  }, [selectedMenu]);
  

  /*eslint-enable */

  const [loadingSave, setLoadingSave] = useState(false);

  const cekKuota = () => {
    Axios.get(
      urlAPI +
        "/public/regonline/cekKuota?params=" +
        JSON.stringify({
          idjadwal: dataStep2?.idjadwal,
          kodeunit: dataStep1?.unit,
          tanggal: moment(dataStep1?.date).format("YYYY-MM-DD"),
          kodedokter: dataStep2?.kodedokter,
        })
    )
      .then((response) => {
        if (
          response?.data?.result[0]?.SELISIH <= 0 &&
          response?.data?.result[0]?.KUOTA !== 0
        ) {
          setMessageState("Maaf Kuota Sudah Habis");
          setShowFailed(true);
          setLoadingUnit(false);
        } else {
          setLoadingSave(true);
          setMessageState("");
          setShowConfirmation(false);
          setConfirmationFrom(null);
          handleSave();
          // setMessageState("sukses");
          // setShowInfo(true);
        }
      })
      .catch((err) => {
        setMessageState(
          err?.response?.data?.message ?? err?.response + " on cek kuota"
        );
        setShowFailed(true);
        setLoadingUnit(false);
        setLoadingSave(false);
      });
  };

  const handleSave = () => {
    Axios.post(urlAPI + "/public/regonline/tambah", {
      isBPJS:
        dataStep3?.jaminan === "bpjs" && unitJenis3 !== "PPK1" ? true : false,
      sbu: dataStep1?.sbu,
      kuota: dataBPJS?.kuota,
      dataSIRS: {
        kodeunit: dataStep1?.unit,
        tanggal: moment(dataStep1?.date).format("YYYY-MM-DD"),
        kodedokter: dataStep2?.kodedokter,
        ruang: dataStep2?.ruang,
        jam: dataStep2?.jam,
        norm: dataStep3?.norm,
        prenobooking: moment(dataStep1?.date).format("YYYYMMDD"),
        tlp: dataStep4?.tlp,
        noasuransi: dataStep3?.noasuransi,
        jaminan: dataStep3?.jaminan,
        noktp: dataStep3?.noktp,
        nama: dataStep3?.nama,
        tgllahir: moment(dataStep3?.tgllahir).format("YYYY-MM-DD"),
        kelamin: dataStep3?.kelamin,
        alamat: dataStep3?.alamat,
        nonBpjs: dataStep4?.nonBpjs,
        paketmcu: dataStep3?.paketmcu,
      },
      dataBPJS:
        dataStep3?.jaminan !== "bpjs" && unitJenis3 !== "PPK1"
          ? null
          : {
              jenispasien: "JKN",
              nomorkartu: noBPJS.trim(),
              nik:
                dataRujukan[0]?.peserta?.nik === null
                  ? dataStep3?.noktp.trim()
                  : dataRujukan[0]?.peserta?.nik.trim(),
              nohp:
                dataRujukan[0]?.peserta?.mr?.noTelepon !== "" &&
                dataRujukan[0]?.peserta?.mr?.noTelepon !== null
                  ? dataRujukan[0]?.peserta?.mr?.noTelepon
                  : dataStep4?.tlp.trim(),
              kodepoli: dataRujukan.length > 0 ? dataStep2?.kodeunitbpjs : null,
              namapoli:
                dataRujukan.length > 0
                  ? dataRujukan[0]?.poliRujukan?.nama
                  : null,
              pasienbaru: 0,
              norm: dataStep3?.norm,
              tanggalperiksa: moment(dataStep1?.date).format("YYYY-MM-DD"),
              kodedokter: dataStep2?.kodedokterbpjs,
              namadokter: dataStep2?.namadokter,
              jampraktek:
                dataStep2?.jam === null
                  ? "00:00-23:59"
                  : dataStep2?.jam.replaceAll(" ", ""),

              jeniskunjungan:
                SEP === 0 || SEP === "0"
                  ? 1
                  : dataStep2?.kodeunitbpjs ===
                    dataRujukan[0]?.poliRujukan?.kode
                  ? suratKontrol[0]?.noSuratKontrol !== ""
                    ? 3
                    : 2
                  : 2,
              nomorreferensi:
                SEP === 0 || SEP === "0"
                  ? dataRujukan[0]?.noKunjungan
                  : dataStep2?.kodeunitbpjs ===
                    dataRujukan[0]?.poliRujukan?.kode
                  ? suratKontrol[0]?.noSuratKontrol !== ""
                    ? suratKontrol[0]?.noSuratKontrol
                    : "1302R" +
                      moment(dataStep1?.date).format("YYYYMMDD") +
                      dataStep3?.norm
                  : "1302R" +
                    moment(dataStep1?.date).format("YYYYMMDD") +
                    dataStep3?.norm,
              estimasidilayani:
                dataStep2?.jam.length === 13
                  ? moment(
                      dataStep1?.date +
                        " " +
                        dataStep2?.jam.substring(0, 5) +
                        ":00"
                    ).valueOf()
                  : moment(dataStep1?.date + " 00:00:00").valueOf(),
              keterangan:
                "Peserta harap 30 menit lebih awal guna pencatatan administrasi.",

              kodebooking: null,
              sisakuotajkn: null,
              kuotajkn: null,
              sisakuotanonjkn: null,
              kuotanonjkn: null,
              nomorantrean: null,
              angkaantrean: null,
            },
    })
      .then((response) => {
        const responseData = response?.data?.result;
        // setSuccessState({
        //   sbuname: dataStep1?.sbuname,
        //   unitname: dataStep1?.unitname,
        //   doktername: dataStep2?.namadokter,
        //   tanggal: dataStep1?.date,
        //   jam: dataStep2?.jam,
        //   nobooking: responseData?.nobooking,
        //   antrian: responseData?.antrian,
        //   rs: dataStep1?.rs,
        //   ramayanaNonPG: responseData?.ramayanaNonPG,
        //   jaminan: dataStep3?.jaminan,
        //   nama_pasien: dataStep3?.nama,
        // });
        setDataStep1(initStep1);
        setDataStep2(initStep2);
        setDataStep3(initStep2);
        setLoadingSave(false);
        if (response?.data?.kirimbpjs === "sukses") {
          history.push("/ticket/" + responseData?.nobooking + "/green"); //tampilan sukses pindah ke /src/ticket/index
        } else if (response?.data?.kirimbpjs === "gagal") {
          history.push("/ticket/" + responseData?.nobooking + "/red"); //tampilan sukses pindah ke /src/ticket/index
        } else {
          history.push("/ticket/" + responseData?.nobooking + "/blue"); //tampilan sukses pindah ke /src/ticket/index
        }
        // setActiveStep(5);
        myRef.current.scrollIntoView();
      })
      .catch((err) => {
        setMessageState(
          err?.response?.data?.message ?? err?.response + " on save"
        );
        setShowFailed(true);
        setLoadingSave(false);
      });
  };

  return (
    <>
      {/* <FloatingWhatsApp
        zIndex={9999}
        phone={dataStep1?.sbu === "DRIYO" ? "6281331518197" : "#"}
        popupMessage={"Hallo, Ada yang bisa kami bantu?"}
      /> */}
      <ModalPengumuman
        show={openPengumuman}
        data={dataPengumuman}
        handleClose={() => {
          setDataPengumuman({});
          setOpenPengumuman(false);
        }}
      />
      <FailedAlert
        show={showFailed}
        message={messageState}
        onConfirm={() => {
          setMessageState("");
          setShowFailed(false);
        }}
      />
      <InfoAlert
        show={showInfo}
        message={messageState}
        onConfirm={() => {
          setMessageState("");
          setShowInfo(false);
        }}
      />
      <ConfirmationAlert
        show={showConfirmation}
        message={messageState}
        onConfirm={() => {
          if (confirmationFrom === "step4") {
            // setLoadingSave(true);
            setMessageState("");
            setShowConfirmation(false);
            setConfirmationFrom(null);
            //handleSave();
            cekKuota();
          } else if (confirmationFrom === "step3") {
            setMessageState("");
            setShowConfirmation(false);
            setConfirmationFrom(null);

            setActiveStep(activeStep + 1);
            myRef.current.scrollIntoView();
          }
        }}
        onCancel={() => {
          setMessageState("");
          setShowConfirmation(false);
          setConfirmationFrom(null);
        }}
      />
    <div style={{ padding: "4px" }}>
    <Row className="g-0 justify-center">
    <Col lg={4} md={4} sm={12} className="p-3">
      <Card style={{ width: "100%", height: "100%", borderRadius: "18px" }}>
        <Card.Body style={style?.CardWelcomeMedia} className="p-2">
          {/* Tampilan untuk HP */}
          <div 
        className="d-flex align-items-center justify-content-center d-md-none d-lg-none"
        style={{ width: "100%", gap: "8px", flexWrap: "nowrap", padding: "8px" }}
      >
        <img 
          src="assets/img/logopgm123.png" 
          alt="logo" 
          style={{ 
            width: "80px", 
            height: "50px", 
            objectFit: "contain", 
            flexShrink: 0, 
          }} 
        />
        <div className="w-100 d-flex flex-column justify-content-center text-start">
          <h1 
            style={{ fontSize: "18px", fontWeight: "bold", margin: "0", color: "#000", whiteSpace: "nowrap", }}
          >
            PETRO GRAHA MEDIKA
          </h1>
          <h4 
            style={{ fontSize: "12px", margin: "0", color: "#00923f", fontWeight: "bold", whiteSpace: "nowrap" }}
          >
            Sahabat Menuju Sehat
          </h4>
          <p 
            style={{ fontSize: "13px", color: "#1f1a17", fontWeight: "bold", margin: "8px 0 0 0" }}
          >
            RS PETROKIMIA GRESIK GROUP
          </p>
        </div>
      </div>
          {/* Tampilan untuk Desktop */}
          <div className="text-center d-none d-md-block">
            <img 
              src="assets/img/logopgm.png" 
              alt="gambar" 
              className="w-75"
            />
          </div>
        </Card.Body>
      </Card>
    </Col>


    <Col className="d-none d-md-block" lg={8} md={8}>
      <Card style={style?.CardWelcome}>
        <Card.Body style={style?.CardWelcomeMedia} className="p-2">
          <Row className="g-0">
            <Col lg={8} md={8}>
              <h1 className="mb-1">
                <strong>Selamat Datang!</strong>
              </h1>
              <h4 className="mb-1">Registrasi Rawat Jalan Online</h4>
              <p className="mb-0">
                Silahkan isi dan pilih data di bawah ini untuk melakukan registrasi unit rawat jalan secara online.
              </p>
            </Col>
            <Col lg={4} md={4} className="text-center">
              <img
                src="assets/img/welcome-img.svg"
                alt="gambar"
                className="w-100"
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  </Row>
  
  <Container>
  <Row className="g-0 justify-content-center mt-2">
  {selectorSBU.map((obj, index) => (
    <Col key={index} xs={12} sm={6} md={4} lg={4} className="p-2">
      
      {/* Card untuk Desktop */}
      <Card
        className="text-center p-1 shadow-sm h-100 d-none d-md-flex"
        role="button"
        style={{
          cursor: "pointer",
          transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          transform: hoverIndex === index ? "scale(1.03)" : "scale(1)",
          boxShadow: hoverIndex === index 
            ? "0px 4px 8px rgba(0,0,0,0.12)" 
            : "0px 2px 4px rgba(0,0,0,0.06)",
          padding: "16px",
        }}
        onMouseEnter={() => setHoverIndex(index)}
        onMouseLeave={() => setHoverIndex(null)}
        onClick={() => {
          handleSelect(obj);
          setDataStep1({ ...dataStep1, sbu: obj.value });
          fetchSelectorUnit(obj.value);
          setShowModel(true);
        }}
      >
        <Card.Img
          variant="top"
          src={obj.img}
          alt={obj.label}
          className="w-100"
          style={{
            width: "150px",
            height: "300px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />
        <Card.Body className="d-flex flex-column align-items-center p-2">
          <Card.Text className="fw-bold" style={{ fontSize: "18px", marginBottom: "20px" }}>
            {obj.label}
          </Card.Text>
        </Card.Body>
      </Card>

      {/* Card untuk Mobile */}
      <Card
        className="text-center p-2 shadow-sm h-100 d-md-none"
        role="button"
        style={{
          cursor: "pointer",
          transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          transform: hoverIndex === index ? "scale(1.03)" : "scale(1)",
          boxShadow: hoverIndex === index 
            ? "0px 4px 8px rgba(0,0,0,0.12)" 
            : "0px 2px 4px rgba(0,0,0,0.06)",
          padding: "8px",
        }}
        onMouseEnter={() => setHoverIndex(index)}
        onMouseLeave={() => setHoverIndex(null)}
        onClick={() => {
          handleSelect(obj);
          setDataStep1({ ...dataStep1, sbu: obj.value });
          fetchSelectorUnit(obj.value);
          setShowModel(true);
        }}
      >
        <Card.Img
          variant="top"
          src={obj.img}
          alt={obj.label}
          style={{
            width: "80px",
            height: "80px",
            objectFit: "cover",
            borderRadius: "8px",
            marginRight: "12px",
          }}
        />
        <Card.Body className="d-flex flex-column align-items-start p-0">
          <Card.Text className="fw-bold" style={{ fontSize: "14px", marginBottom: "0px" }}>
            {obj.label}
          </Card.Text>
        </Card.Body>
      </Card>
    </Col>
  ))}
</Row>

{/* Modal untuk SBU */}
{showModel && selectedSBU && (
  <Modal
    show={showModel}
    onHide={() => setShowModel(false)}
    size="lg"
    centered
    backdrop="static"
    keyboard={false}
    style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
  >
    <Modal.Header closeButton className="text-center bg-light">
      <Modal.Title className="w-100">{selectedSBU.label}</Modal.Title>
    </Modal.Header>
    <Modal.Body className="text-center bg-light">
      {/* Card untuk Image & Profile */}
      <Card className="shadow-sm border-0 mb-4 p-3" style={{ borderRadius: "12px" }}>
        <Card.Body className="text-center">
          <img
            src={selectedSBU.img}
            alt={selectedSBU.profile}
            className="img-fluid mb-3 shadow-sm"
            style={{
              borderRadius: "12px",
              maxHeight: "200px",
              objectFit: "cover",
              width: "100%",
              maxWidth: "400px",
            }}
          />
            <Accordion className="shadow-sm rounded">
              <Accordion.Item eventKey="0">
                <Accordion.Header className="w-100 d-flex justify-content-center">
                  <span className="fw-bold text-center" style={{ color: "#097a75", width: "100%" }}>
                    🏥 Profile Rumah Sakit
                  </span>
                </Accordion.Header>
                <Accordion.Body className="bg-light text-dark p-3 rounded-bottom">
                <p className="fw-bold mb-2" style={{ textAlign: "justify" }}> {selectedSBU.profile} </p>
                  <div className="text-center">
                    <a
                      href={selectedSBU.location}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn fw-bold w-100"
                      style={{
                        backgroundColor: "#097a75",
                        color: "#fff",
                        borderRadius: "8px",
                        padding: "10px",
                        textAlign: "center",
                        textDecoration: "none",
                      }}
                    >
                      📍 Lihat Lokasi
                    </a>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
        </Card.Body>
      </Card>

      {/* Card untuk Menu Layanan */}
      <Card className="shadow-sm border-0 p-3" style={{ borderRadius: "12px" }}>
        <Card.Body>
          <Row className="row-cols-2 row-cols-md-3 g-3 justify-content-center">
            {menuLayanan.map((obj, index) => (
              <Col key={index} className="d-flex align-items-stretch">
                <Card
                  className="text-center p-3 shadow-sm border-0 w-100"
                  role="button"
                  style={{
                    cursor: "pointer",
                    borderRadius: "12px",
                    transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.boxShadow = "0px 6px 12px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "0px 3px 8px rgba(0,0,0,0.08)";
                  }}
                  onClick={() => handleOpenModal(obj)}
                >
                  <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                    {obj.icon}
                    <Card.Text className="mt-2 fw-bold" style={{ fontSize: "16px" }}>
                      {obj.label}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Card.Body>
      </Card>
    </Modal.Body>
  </Modal>
  )}
  </Container>

  {/* Slider Mobile */}
    <Row className="d-block d-md-none mt-3">
    <Col sm={12}>
    <Card className="shadow-lg border-0 rounded-100">
      <Card.Body>
        <div className="glide" ref={sliderRef}>
          <div className="glide__track" data-glide-el="track">
            <ul className="glide__slides">
              <li className="glide__slide">
                <img src="assets/img/flyer1.png" alt="Slide 1" className="w-100 slider-img" />
              </li>
              <li className="glide__slide">
                <img src="assets/img/flyer2.png" alt="Slide 2" className="w-100 slider-img" />
              </li>
              <li className="glide__slide">
                <img src="assets/img/flyer3.png" alt="Slide 3" className="w-100 slider-img" />
              </li>
            </ul>
          </div>
          <div className="glide__arrows" data-glide-el="controls">
              <button className="glide__arrow glide__arrow--left" data-glide-dir="<">‹</button>
              <button className="glide__arrow glide__arrow--right" data-glide-dir=">">›</button>
            </div>
          </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>

    <Container className="py-4">
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedMenu?.label}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedMenu?.label === "Daftar Online" &&                   
              <Card style={{ ...style.Card, overflow: "visible" }} ref={myRef}>
              {loadingSave ? (
                <Card.Body>
                  <br />
                  <Center>
                    <h3>Sedang Menyimpan, Harap Tunggu...</h3>
                  </Center>
                </Card.Body>
              ) : (
                <Card.Body>
                  {activeStep === 1 ? (
                    <Step1Page
                      dataStep1={dataStep1}
                      setDataStep1={setDataStep1}
                      selectorSBU={selectorSBU}
                      selectorRS={selectorRS}
                      fetchSelectorUnit={(event) => {
                        setLoadingUnit(true);
                        fetchSelectorUnit(event);
                      }}
                      selectorUnit={selectorUnit}
                      loadingUnit={loadingUnit}
                      handleNext={() => {
                        cekTanggalServer();
                        // setLoadingPengumuman(true);
                        // fetchCheckPengumuman();
                      }}
                      setUnitJenis3={setUnitJenis3}
                      loadingPengumuman={loadingPengumuman}
                    />
                  ) : activeStep === 2 ? (
                    <Step2Page
                      dataStep1={dataStep1}
                      setDataStep1={setDataStep1}
                      selectorSBU={selectorSBU}
                      selectorRS={selectorRS}
                      fetchSelectorUnit={(event) => {
                        setLoadingUnit(true);
                        fetchSelectorUnit(event);
                      }}
                      selectorUnit={selectorUnit}
                      loadingUnit={loadingUnit}
                      dataStep2={dataStep2}
                      setDataStep2={setDataStep2}
                      setMessageState={setMessageState}
                      setShowFailed={setShowFailed}
                      setShowInfo={setShowInfo}
                      handleNext={() => {
                        if (dataStep1.rs === "Pernah") {
                          setActiveStep(activeStep + 1);
                          myRef.current.scrollIntoView();
                        } else if (dataStep1.rs === "Belum") {
                          setActiveStep(6);
                          myRef.current.scrollIntoView();
                        }
                      }}
                      setLoadingUnit={setLoadingUnit}
                      initStep2={initStep2}
                      dataBPJS={dataBPJS}
                      setDataBPJS={setDataBPJS}
                      handlePrev={() => {
                        setActiveStep(activeStep - 1);
                        myRef.current.scrollIntoView();
                      }}
                      setUnitJenis3={setUnitJenis3}
                    />
                  ) : activeStep === 3 ? (
                    <Step3Page
                      dataStep1={dataStep1}
                      dataStep2={dataStep2}
                      dataStep3={dataStep3}
                      setDataStep3={setDataStep3}
                      initStep3={initStep3}
                      setMessageState={setMessageState}
                      setShowFailed={setShowFailed}
                      handlePrev={() => {
                        setActiveStep(activeStep - 1);
                        myRef.current.scrollIntoView();
                      }}
                      handleNext={() => {
                        if (
                          dataStep3?.jaminan === "bpjs" &&
                          dataRujukan[0]?.poliRujukan?.kode !==
                            dataStep2?.kodeunitbpjs
                        ) {
                          setMessageState(
                            "Poli yang Anda pilih berbeda dengan poli rujukan Anda, Apakah anda yakin melanjutkan pendaftaran?"
                          );
                          setShowConfirmation(true);
                          setConfirmationFrom("step3");
                        } else {
                          setActiveStep(activeStep + 1);
                          myRef.current.scrollIntoView();
                        }
                      }}
                      dataBPJS={dataBPJS}
                      dataRujukan={dataRujukan}
                      setDataRujukan={setDataRujukan}
                      noBPJS={noBPJS}
                      setNoBPJS={setNoBPJS}
                      unitJenis3={unitJenis3}
                      setSEP={setSEP}
                      SEP={SEP}
                      setSuratKontrol={setSuratKontrol}
                      suratKontrol={suratKontrol}
                    />
                  ) : activeStep === 4 ? (
                    <Step4Page
                      dataStep1={dataStep1}
                      dataStep2={dataStep2}
                      dataStep3={dataStep3}
                      dataStep4={dataStep4}
                      setDataStep4={setDataStep4}
                      dataRujukan={dataRujukan}
                      handlePrev={() => {
                        setActiveStep(activeStep - 2);
                        myRef.current.scrollIntoView();
                      }}
                      handleSave={() => {
                        myRef.current.scrollIntoView();
                        setMessageState(
                          "Apakah anda yakin data sudah benar dan melakukan registrasi online? "
                        );
                        setShowConfirmation(true);
                        setConfirmationFrom("step4");
                      }}
                      loadingSave={loadingSave}
                      setSEP={setSEP}
                      SEP={SEP}
                    />
                  ) : activeStep === 5 ? (
                    <SuccessPage
                      dataStep1={dataStep1}
                      successState={successState}
                      handleRegAgain={() => {
                        myRef.current.scrollIntoView();
                        setSuccessState(initSuccessState);
                        setActiveStep(1);
                      }}
                    />
                  ) : activeStep === 6 ? (
                    <Step6Page
                      dataStep1={dataStep1}
                      dataStep2={dataStep2}
                      dataStep3={dataStep3}
                      dataStep4={dataStep4}
                      setDataStep3={setDataStep3}
                      setDataStep4={setDataStep4}
                      handlePrev={() => {
                        setActiveStep(2);
                        myRef.current.scrollIntoView();
                      }}
                      handleNext={() => {
                        setActiveStep(4);
                        myRef.current.scrollIntoView();
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </Card.Body>
              )}
            </Card>}

          {selectedMenu?.label === "Riwayat Kunjungan" &&               
            <PelangganSection
              filterRiwayat={filterRiwayat}
              setFilterRiwayat={setFilterRiwayat}
              selectorSBU={selectorSBU}
              fetchSelectorUnitAntrian={fetchSelectorUnitAntrian}
              selectorAntrian={selectorAntrian}
              loadingAntrian={loadingAntrian}
              setLoadingAntrian={setLoadingAntrian}
              setMessageState={setMessageState}
              setShowFailed={setShowFailed}
              setShowInfo={setShowInfo}
              source={'Riwayat'}
            />}

          {selectedMenu?.label === "Jadwal Dokter" &&               
            <JadwalSection
              filterJadwal={filterJadwal}
              setFilterJadwal={setFilterJadwal}
              selectorSBU={selectorSBU}
              fetchSelectorUnit={fetchSelectorUnit}
              selectorUnit={selectorUnit}
              loadingUnit={loadingUnit}
              setLoadingUnit={setLoadingUnit}
              setMessageState={setMessageState}
              setShowFailed={setShowFailed}
              setShowInfo={setShowInfo}
              selectedSBU={dataStep1.sbu}
            />
          }
                  
          {selectedMenu?.label === "Informasi Antrian" &&               
            <AntrianSection
            filterAntrian={filterAntrian}
            setFilterAntrian={setFilterAntrian}
            selectorSBU={selectorSBU}
            fetchSelectorUnitAntrian={fetchSelectorUnitAntrian}
            selectorAntrian={selectorAntrian}
            loadingAntrian={loadingAntrian}
            setLoadingAntrian={setLoadingAntrian}
            setMessageState={setMessageState}
            setShowFailed={setShowFailed}
            setShowInfo={setShowInfo}
            />}

          {selectedMenu?.label === "Rencana Kontrol" && 
            <PelangganSection
              filterAntrian={filterAntrian}
              setFilterAntrian={setFilterAntrian}
              selectorSBU={selectorSBU}
              fetchSelectorUnitAntrian={fetchSelectorUnitAntrian}
              selectorAntrian={selectorAntrian}
              loadingAntrian={loadingAntrian}
              setLoadingAntrian={setLoadingAntrian}
              setMessageState={setMessageState}
              setShowFailed={setShowFailed}
              setShowInfo={setShowInfo}
              source={'RencanaKontrol'}
            />}
                      
          {selectedMenu?.label === "Kuisioner Pelanggan" && 
              <PelangganSection
              filterAntrian={filterAntrian}
              setFilterAntrian={setFilterAntrian}
              selectorSBU={selectorSBU}
              fetchSelectorUnitAntrian={fetchSelectorUnitAntrian}
              selectorAntrian={selectorAntrian}
              loadingAntrian={loadingAntrian}
              setLoadingAntrian={setLoadingAntrian}
              setMessageState={setMessageState}
              setShowFailed={setShowFailed}
              setShowInfo={setShowInfo}
              source={'Pelanggan'}
            />}

        </Modal.Body>
      </Modal>
    </Container>
        <footer>
          <p className="mb-0 clearfix">
            <span style={{ float: "right" }}>
              Developed by{" "}
              <strong>
                <a
                  href="http://petrograhamedika.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "black" }}
                >
                  Bagian SIRS - PT Petro Graha Medika
                </a>
              </strong>
            </span>
          </p>
        </footer>
      </div>
    </>
  );
}
